import { INTEGRATION_FORM_CONTENT } from 'modules/mobileApps/constants';
import { IntegrationFormField } from 'modules/mobileApps/context/integrationForm';
import { APNS_INTEGRATION_FORM_ID } from '../ApnsIntegrationForm';
import { TextInputRow } from '../ApnsIntegrationForm.styled';
import { FileDropzoneField } from '../components';
import { TextInputField } from '../components/TextInputField';

const { inputs } = INTEGRATION_FORM_CONTENT.authMethods.p8AuthKey;

export const P8FormPart = () => {
  return (
    <>
      <FileDropzoneField
        data-test={`${APNS_INTEGRATION_FORM_ID}-upload-p8-file`}
        accept={{ 'application/x-pkcs8': ['.p8'] }}
        name={IntegrationFormField.p8File}
      />
      <TextInputRow>
        <TextInputField
          data-test={`${APNS_INTEGRATION_FORM_ID}-key-id-field`}
          labelText={inputs.keyID.label}
          name={IntegrationFormField.keyID}
        />
        <TextInputField
          data-test={`${APNS_INTEGRATION_FORM_ID}-team-id-field`}
          labelText={inputs.teamID.label}
          name={IntegrationFormField.teamID}
        />
        <TextInputField
          data-test={`${APNS_INTEGRATION_FORM_ID}-bundle-id-field`}
          labelText={inputs.bundleID.label}
          name={IntegrationFormField.bundleID}
        />
      </TextInputRow>
    </>
  );
};
